import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    container: {
      marginTop: '2%'
    }
  })
